import { getPrimaryRole, hasRole } from "../utilities/role";
import { api } from "./api";
import { type FeatureFlag, Role } from "./api.types";
import { useTypedSelector } from "./store";

export function useAuth() {
  const { orgSlug } = useTypedSelector((state) => state.local);
  const getUser = api.useGetUserQuery(null);

  const user = getUser.currentData;

  if (!user) {
    throw new Error("User not authenticated");
  }

  const organization = user.organizations.find((o) => o.slug === orgSlug);
  if (!organization) {
    throw new Error("Organization not found");
  }

  const role = getPrimaryRole(organization.roles ?? []);

  return { user, organization, role };
}

export function useAuthHasFeatureFlag(checkFlag: FeatureFlag) {
  const { user, organization } = useAuth();
  if (user.feature_flags.includes(checkFlag)) {
    return true;
  }
  if (organization.feature_flags.includes(checkFlag)) {
    return true;
  }
  return false;
}

export function useAuthHasRole(...checkRoles: Role[]) {
  const { role } = useAuth();
  for (const checkRole of checkRoles) {
    if (hasRole(role, checkRole)) {
      return true;
    }
  }
  return false;
}
